import React, { useState, useEffect } from 'react';
import { Form } from '@rocketseat/unform';
import history from '~/services/history';
import logo from '~/assets/Logo Apolar-pretaeazul01.png';
import { Content } from './styles';

export default function SendEmail() {
  const [newPassword, setNewPassword] = useState(false);
  const newEmail = localStorage.getItem('message');

  useEffect(() => {
    setNewPassword(localStorage.getItem('newPassword'));
  }, []);

  useEffect(() => {
    if (!newEmail) {
      history.push('/RecuperarSenha');
    }
  }, [newEmail]);

  function navigateToLogin() {
    history.push('/');
  }

  return (
    <Content>
      <img src={logo} alt="Logo Apolar Imóveis" />
      <Form>
        {newPassword ? (
          <div className="infoForget">RECUPERAR SENHA</div>
        ) : (
          <div className="info">
            Identificamos que você ainda não tem uma senha de acesso cadastrada.
          </div>
        )}
        <div className="message">
          Enviada nova senha para o e-mail {newEmail}
        </div>

        <button type="submit" onClick={navigateToLogin}>
          Login
        </button>
      </Form>
    </Content>
  );
}
